module.exports = __webpack_public_path__ + "img/offer.6203b22f.png";